import React, { useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import AgentLayout from "../components/AgentLayout";
import { useParams } from "react-router-dom";

const SetUserLimit = () => {

    const { userId } = useParams();
    const [staticId, setStaticId] = useState("");
    const [displayUsername, setDisplayUsername] = useState("");
    const [messageLimit, setMessageLimit] = useState({
        status: false,
        message: ""
    });
    const [animationLimit, handleAnimationLimit] = useState(false);

    const [search, setSearch] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [searching, setSearching] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const formatTruncate = (value) => { return Number(value || 0).toLocaleString("en-IN"); };

    const [soccer, handleSoccer] = useState({ soccer: 0, soccerOld: 0 });
    const [tennis, handleTennis] = useState({ tennis: 0, tennisOld: 0 });
    const [cricket, handleCricket] = useState({ cricket: 0, cricketOld: 0 });
    const [fancy, handleFancy] = useState({ fancy: 0, fancyOld: 0 });
    const [hrace, handleHrace] = useState({ hrace: 0, hraceOld: 0 });
    const [greyhound, handleGreyhound] = useState({ greyhound: 0, greyhoundOld: 0 });
    const [bookMaker, handleBookMaker] = useState({ bookMaker: 0, bookMakerOld: 0 });
    const [teenpatiStudio, handleTeenpatiStudio] = useState({ teenpatiStudio: 0, teenpatiStudioOld: 0 });
    const [galaxyStudio, handleGalaxy] = useState({ galaxyStudio: 0, galaxyStudioOld: 0 });
    const [betfair, handleBetfair] = useState({ betfair: 0, betfairOld: 0 });
    const [casino, handleCasino] = useState({ casino: 0, casinoOld: 0 });

    const handleSearch = async () => {
        if (!search.trim()) {
            setErrorMessage("Please enter username");
            return;
        }
        try {
            setSearching(true);
            setErrorMessage("");
            setSelectedUser(null);

            const response = await axiosInstance.get(
                "company/get-bet-limit-single",
                { params: { username: search.trim() } }
            );

            if (response?.data?.status) {
                const user = response.data.user;
                const limitObj = response.data.betlmit || {};
                setSelectedUser(user);
                setStaticId(user._id);
                setDisplayUsername(user.uname);

                handleSoccer({
                    soccer: Number(limitObj.soccer) || 0,
                    soccerOld: Number(limitObj.soccer) || 0
                });
                handleTennis({
                    tennis: Number(limitObj.tennis) || 0,
                    tennisOld: Number(limitObj.tennis) || 0
                });
                handleCricket({
                    cricket: Number(limitObj.cricket) || 0,
                    cricketOld: Number(limitObj.cricket) || 0
                });
                handleFancy({
                    fancy: Number(limitObj.fancy) || 0,
                    fancyOld: Number(limitObj.fancy) || 0
                });
                handleHrace({
                    hrace: Number(limitObj.hrace) || 0,
                    hraceOld: Number(limitObj.hrace) || 0
                });
                handleGreyhound({
                    greyhound: Number(limitObj.greyhound) || 0,
                    greyhoundOld: Number(limitObj.greyhound) || 0
                });
                handleBookMaker({
                    bookMaker: Number(limitObj.bookMaker) || 0,
                    bookMakerOld: Number(limitObj.bookMaker) || 0
                });
                handleTeenpatiStudio({
                    teenpatiStudio: Number(limitObj.teenpatiStudio) || 0,
                    teenpatiStudioOld: Number(limitObj.teenpatiStudio) || 0
                });
                handleGalaxy({
                    galaxyStudio: Number(limitObj.galaxyStudio) || 0,
                    galaxyStudioOld: Number(limitObj.galaxyStudio) || 0
                });
                handleBetfair({
                    betfair: Number(limitObj.betfair) || 0,
                    betfairOld: Number(limitObj.betfair) || 0
                });
                handleCasino({
                    casino: Number(limitObj.casino) || 0,
                    casinoOld: Number(limitObj.casino) || 0
                });
            }
        }

        catch (error) {
            console.error("Error searching user:", error);
            setSelectedUser(null);
            setErrorMessage(error?.response?.data?.message || "Something went wrong");
        }

        finally {
            setSearching(false);
        }
    };


    const handleSaveBetLimit = async () => {
        if (!selectedUser?._id) {
            setMessageLimit({
                status: false,
                message: "Please search and select a user first."
            });
            return;
        }

        handleAnimationLimit(true);
        setMessageLimit({ status: false, message: "" });

        const userObj = {
            userId: selectedUser._id,
            soccer: soccer.soccer,
            tennis: tennis.tennis,
            cricket: cricket.cricket,
            fancy: fancy.fancy,
            hrace: hrace.hrace,
            casino: casino.casino,
            greyhound: greyhound.greyhound,
            bookMaker: bookMaker.bookMaker,
            teenpatiStudio: teenpatiStudio.teenpatiStudio,
            galaxyStudio: galaxyStudio.galaxyStudio,
            betfair: betfair.betfair
        };

        try {
            const response = await axiosInstance.post(
                "/company/save-bet-limit-single",
                userObj
            );

            if (response?.data?.status === true) {
                setMessageLimit({
                    status: true,
                    message: response.data.message || "Bet limits saved successfully."
                });
            } else {
                setMessageLimit({
                    status: false,
                    message: response?.data?.message || "Unable to save bet limits."
                });
            }
        } catch (error) {
            setMessageLimit({
                status: false,
                message:
                    error.response?.data?.message || "Something went wrong while saving."
            });
        } finally {
            handleAnimationLimit(false);
        }
    };


    return (
        <AgentLayout>
            <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-default">

                        <div className="card" style={{ margin: "10px 20px 20px" }}>
                            <div className="card-header">
                                <strong className="site_family">
                                    Set User Limit
                                </strong>
                            </div>
                            <div className="card-body">
                                <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Username"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        style={{ width: "350px", marginTop: "10px" }}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSearch}
                                        disabled={searching}
                                    >
                                        {searching ? "Searching..." : "Search"}
                                    </button>
                                </div>
                                {errorMessage && (
                                    <div className="text-danger" style={{ marginTop: "10px" }}>
                                        {errorMessage}
                                    </div>
                                )}
                            </div>
                        </div>



                        {/* Form */}
                        {selectedUser && (
                            <>
                                <div className="col-12 col-md-12" style={{ marginTop: "20px" }}>
                                    <div className="card" style={{ marginRight: "5px" }}>
                                        <div className="card-header">
                                            <strong className="site_family">
                                                Bet Limit
                                            </strong>
                                            {selectedUser && (
                                                <span className="ms-2">
                                                    &nbsp;(Username: {selectedUser.uname})
                                                </span>
                                            )}
                                        </div>


                                        <div className="card-body">

                                            <div className="form-group row">
                                                <label className="col-4 col-md-3 col-form-label">
                                                    Soccer
                                                </label>
                                                <div className="col-8 col-md-6">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={soccer.soccer}
                                                        onChange={(e) =>
                                                            handleSoccer({
                                                                ...soccer,
                                                                soccer: Number(e.target.value) || 0
                                                            })
                                                        }
                                                    />

                                                    <span className="field-validation-valid">
                                                        Max: {formatTruncate(soccer.soccerOld)}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-4 col-md-3 col-form-label">
                                                    Tennis
                                                </label>
                                                <div className="col-8 col-md-6">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={tennis.tennis}
                                                        onChange={(e) =>
                                                            handleTennis({
                                                                ...tennis,
                                                                tennis: Number(e.target.value) || 0
                                                            })
                                                        }
                                                    />
                                                    <span className="field-validation-valid">
                                                        Max: {formatTruncate(tennis.tennisOld)}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-4 col-md-3 col-form-label">
                                                    Cricket
                                                </label>
                                                <div className="col-8 col-md-6">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={cricket.cricket}
                                                        onChange={(e) =>
                                                            handleCricket({
                                                                ...cricket,
                                                                cricket: Number(e.target.value) || 0
                                                            })
                                                        }
                                                    />
                                                    <span className="field-validation-valid">
                                                        Max: {formatTruncate(cricket.cricketOld)}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-4 col-md-3 col-form-label">
                                                    Fancy
                                                </label>
                                                <div className="col-8 col-md-6">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={fancy.fancy}
                                                        onChange={(e) =>
                                                            handleFancy({
                                                                ...fancy,
                                                                fancy: Number(e.target.value) || 0
                                                            })
                                                        }
                                                    />
                                                    <span className="field-validation-valid">
                                                        Max: {formatTruncate(fancy.fancyOld)}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-4 col-md-3 col-form-label">
                                                    Races
                                                </label>
                                                <div className="col-8 col-md-6">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={hrace.hrace}
                                                        onChange={(e) =>
                                                            handleHrace({
                                                                ...hrace,
                                                                hrace: Number(e.target.value) || 0
                                                            })
                                                        }
                                                    />
                                                    <span className="field-validation-valid">
                                                        Max: {formatTruncate(hrace.hraceOld)}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-4 col-md-3 col-form-label">
                                                    Casino
                                                </label>
                                                <div className="col-8 col-md-6">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={casino.casino}
                                                        onChange={(e) =>
                                                            handleCasino({
                                                                ...casino,
                                                                casino: Number(e.target.value) || 0
                                                            })
                                                        }
                                                    />
                                                    <span className="field-validation-valid">
                                                        Max: {formatTruncate(casino.casinoOld)}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-4 col-md-3 col-form-label">
                                                    Greyhound
                                                </label>
                                                <div className="col-8 col-md-6">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={greyhound.greyhound}
                                                        onChange={(e) =>
                                                            handleGreyhound({
                                                                ...greyhound,
                                                                greyhound: Number(e.target.value) || 0
                                                            })
                                                        }
                                                    />
                                                    <span className="field-validation-valid">
                                                        Max: {formatTruncate(greyhound.greyhoundOld)}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-4 col-md-3 col-form-label">
                                                    BookMaker
                                                </label>
                                                <div className="col-8 col-md-6">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={bookMaker.bookMaker}
                                                        onChange={(e) =>
                                                            handleBookMaker({
                                                                ...bookMaker,
                                                                bookMaker: Number(e.target.value) || 0
                                                            })
                                                        }
                                                    />
                                                    <span className="field-validation-valid">
                                                        Max: {formatTruncate(bookMaker.bookMakerOld)}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-4 col-md-3 col-form-label">
                                                    Teenpati Studio
                                                </label>
                                                <div className="col-8 col-md-6">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={teenpatiStudio.teenpatiStudio}
                                                        onChange={(e) =>
                                                            handleTeenpatiStudio({
                                                                ...teenpatiStudio,
                                                                teenpatiStudio:
                                                                    Number(e.target.value) || 0
                                                            })
                                                        }
                                                    />
                                                    <span className="field-validation-valid">
                                                        Max: {formatTruncate(
                                                            teenpatiStudio.teenpatiStudioOld
                                                        )}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-4 col-md-3 col-form-label">
                                                    Galaxy Studio
                                                </label>
                                                <div className="col-8 col-md-6">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={galaxyStudio.galaxyStudio}
                                                        onChange={(e) =>
                                                            handleGalaxy({
                                                                ...galaxyStudio,
                                                                galaxyStudio:
                                                                    Number(e.target.value) || 0
                                                            })
                                                        }
                                                    />
                                                    <span className="field-validation-valid">
                                                        Max: {formatTruncate(
                                                            galaxyStudio.galaxyStudioOld
                                                        )}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-4 col-md-3 col-form-label">
                                                    Betfair Games
                                                </label>
                                                <div className="col-8 col-md-6">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={betfair.betfair}
                                                        onChange={(e) =>
                                                            handleBetfair({
                                                                ...betfair,
                                                                betfair: Number(e.target.value) || 0
                                                            })
                                                        }
                                                    />
                                                    <span className="field-validation-valid">
                                                        Max: {formatTruncate(betfair.betfairOld)}
                                                    </span>
                                                </div>
                                            </div>

                                        </div>

                                        <div style={{ width: "100%", marginTop: "25px", marginBottom: "10px", textAlign: "right" }}>
                                            <button type="button" className="btn btn-primary editsbmtbtnin" style={{ marginRight: "10px" }} onClick={handleSaveBetLimit}>
                                                <strong className="site_family">Submit</strong>
                                            </button>
                                        </div>
                                        {messageLimit.message && (
                                            <div className={`alert ${messageLimit.status ? "alert-success" : "alert-danger"}`}
                                                role="alert"
                                                style={{ margin: "10px" }}
                                            >
                                                {messageLimit.message}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}

                    </div>
                </div>
            </div>

        </AgentLayout>
    );
};

export default SetUserLimit;
